<template>
  <section class="td-salon-car" :style="box">
    <div :class="container">
      <!-- <div v-if="!!image" >
        <div class="td-salon__image">
          <img :src="image" alt="">
        </div>
      </div> -->

      <!-- <div v-if="!!note" class="sec-content__image-text">
        <p>{{note}}</p>
      </div> -->

      <!-- <div v-if="!!textarea" class="">
        <p>{{ textarea }}</p>
      </div> -->

      <div v-if="!!content" class="editor-content" v-html="content">
      </div>
    </div>
  </section>
</template>

<script>
import mixin from '@/mixins/sections/styleSettings'
export default {
  mixins: [mixin],
  computed: {
    // hasData to be in mixin
    /* image() {
      return this.hasData.img && this.hasData.img.file_name
    },
    note() {
      return this.hasData.note
    }, */
    /* textarea() {
      return this.hasData.textarea
    } */
    content() {
      return this.hasData.content
    }
  }
}
</script>
